import storage from '@/plugins/storage'
const systemConfig = storage.get('systemConfig') || {}
const noRenewals = storage.get('noRenewals') || {}
const userinfo = storage.get('userinfo') || {}
export default {
  isLogin: false,
  isBindAlpha: false,
  systemConfig,
  drainagePopVisible: false,
  userinfo,
  noRenewals,
  dialogConfig: {},
  systemNotice:{}
}
